import React from 'react'
import { Card } from 'react-bootstrap'
import AnalyticsPdfChartBar from './AnalyticsPdfChartBar'
import styles from './AnalyticsPdfOverview.module.css'

const AnalyticsPdfTimeChart = ({ pageTimeData }) => {
  const maxTime = Math.max(...pageTimeData.map((p) => p.avgTime))

  return (
    <Card className="mb-4">
      <Card.Body>
        <h5 className="mb-4">Time Spent Per Page</h5>
        <div className={styles.chartContainer}>
          {pageTimeData.map((page) => (
            <AnalyticsPdfChartBar
              key={page.page}
              page={page.page}
              percentage={maxTime > 0 ? (page.avgTime / maxTime) * 100 : 0}
              avgTime={page.avgTime}
            />
          ))}
        </div>
      </Card.Body>
    </Card>
  )
}

export default AnalyticsPdfTimeChart
